<div class="encabezado">
  <div>
    <div>
      <div>
        <h5 class="titulo1">
          <i class="icon-chart-bars"></i> {{ "communication.voip.dashboard_title" | translate }}
          <span class="period-badge" *ngIf="stats">{{ stats.period.from }} — {{ stats.period.to }}</span>
        </h5>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="!isLoading && stats" class="dashboard-content">
    <!-- KPI Cards -->
    <div class="kpi-grid">
      <div class="kpi-card">
        <div class="kpi-icon kpi-primary">
          <i class="icon-phone"></i>
        </div>
        <div class="kpi-data">
          <span class="kpi-value">{{ stats.total_calls }}</span>
          <span class="kpi-label">{{ "communication.voip.total_calls" | translate }}</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon kpi-success">
          <i class="icon-check"></i>
        </div>
        <div class="kpi-data">
          <span class="kpi-value">{{ stats.answer_rate }}%</span>
          <span class="kpi-label">{{ "communication.voip.answer_rate" | translate }}</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon kpi-info">
          <i class="icon-clock"></i>
        </div>
        <div class="kpi-data">
          <span class="kpi-value">{{ formatDuration(stats.avg_duration) }}</span>
          <span class="kpi-label">{{ "communication.voip.avg_duration" | translate }}</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon kpi-warning">
          <i class="icon-hourglass"></i>
        </div>
        <div class="kpi-data">
          <span class="kpi-value">{{ formatTotalTime(stats.total_talk_time) }}</span>
          <span class="kpi-label">{{ "communication.voip.total_talk_time" | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Status breakdown -->
    <div class="status-breakdown">
      <div class="status-item">
        <span class="status-dot dot-success"></span>
        <span class="status-label">{{ "communication.voip.status_answered" | translate }}</span>
        <span class="status-count">{{ stats.by_status?.['answered'] || 0 }}</span>
      </div>
      <div class="status-item">
        <span class="status-dot dot-danger"></span>
        <span class="status-label">{{ "communication.voip.status_missed" | translate }}</span>
        <span class="status-count">{{ stats.by_status?.['missed'] || 0 }}</span>
      </div>
      <div class="status-item">
        <span class="status-dot dot-warning"></span>
        <span class="status-label">{{ "communication.voip.status_busy" | translate }}</span>
        <span class="status-count">{{ stats.by_status?.['busy'] || 0 }}</span>
      </div>
      <div class="status-item">
        <span class="status-dot dot-gray"></span>
        <span class="status-label">{{ "communication.voip.status_failed" | translate }}</span>
        <span class="status-count">{{ stats.by_status?.['failed'] || 0 }}</span>
      </div>
    </div>

    <!-- Charts -->
    <div class="charts-grid">
      <div class="chart-card">
        <h6 class="chart-title">{{ "communication.voip.calls_by_hour" | translate }}</h6>
        <div class="chart-container">
          <canvas #hourlyChart></canvas>
        </div>
      </div>

      <div class="chart-card">
        <h6 class="chart-title">{{ "communication.voip.by_disposition" | translate }}</h6>
        <div class="chart-container">
          <canvas #dispositionChart></canvas>
        </div>
      </div>
    </div>
  </div>
</div>
